import styled from "styled-components";
import { ThemePalette } from "../../../../theme";
import { BusyIndicatorCssProps } from "./BusyIndicator.types";

export const PropelBusySvg = styled.svg<BusyIndicatorCssProps>`
  &.Rectangle-Loader {
    transform: rotate(180deg);
  }
  fill: ${(props: BusyIndicatorCssProps) =>
    props.fillColor ? props.fillColor : props.theme!.colorPrimary};
`;

PropelBusySvg.defaultProps = {
  theme: ThemePalette,
};
